import { Injectable } from '@angular/core';
import { EnvironmentService } from '../core/environment.service';

@Injectable({
    providedIn: 'root'
})
export class SearchConfigService {
    public readonly claims: string = `${this.environmentService.environmentConfig.claimsManagerApiUrl}v1/claims/search`;
    public readonly cases: string = `${this.environmentService.environmentConfig.caseApiUrl}v1/cases/search`;
    public readonly users: string = `${this.environmentService.environmentConfig.userApiUrl}v1/users/search`;
    public readonly serviceProviders: string = `${this.environmentService.environmentConfig.serviceProvidersApiUrl}v1/serviceproviders/search`;
    public readonly clients: string = `${this.environmentService.environmentConfig.clientApiUrl}v1/clients/search`;
    public readonly payments: string = `${this.environmentService.environmentConfig.claimsManagerApiUrl}v1/invoice-payments/search`;
    public readonly paymentExports: string = `${this.environmentService.environmentConfig.claimsManagerApiUrl}v1/invoice-payment-exports/search`;
    public readonly paymentImports: string = `${this.environmentService.environmentConfig.claimsManagerApiUrl}v1/invoice-payment-imports/search`;
    public readonly products: string = `${this.environmentService.environmentConfig.productManagerApiUrl}v2/products`;
    public readonly calls: string = `${this.environmentService.environmentConfig.callApiUrl}v1/calls/search`;

    constructor(private environmentService: EnvironmentService) {}

    getCaseHistoryEndpoint(caseId: number): string {
        return `${this.environmentService.environmentConfig.caseHistoryApiUrl}v1/cases/${caseId}/history/search`;
    }

    getNoteSearchEndpoint(caseId: number): string {
        return `${this.environmentService.environmentConfig.caseApiUrl}v1/cases/${caseId}/notes/search`;
    }
}
